<template>
  <div class="content">
    <div class="steps-content">
      <!-- 填写预约信息 -->
      <div>
        <a-form :form="form">

          <!-- 正常表单 -->
          <div class="flexline">
            <a-form-item :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol" label="姓名">
              <a-input v-decorator="[
          'name',
          { rules: [{ required: true, message: '请输入姓名'}] },
        ]" placeholder="请输入姓名" />
            </a-form-item>

            <a-form-item :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol" label="护照号">
              <a-input v-decorator="[
          'passportId',
          { rules: [{ required: true, message: '请输入护照号'}] },
        ]" placeholder="请输入护照号" />
            </a-form-item>
          </div>

          <!-- 正常表单 -->
          <div class="flexline">
            <a-form-item :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol" label="手机号">
              <a-input v-decorator="[
          'phoneNumber',
          { rules: [{ required: true, message: '请输入合法的手机号码' ,pattern: /^(0|86|17951)?(13[0-9]|15[0-9]|17[0-9]|19[0-9]|18[0-9]|14[0-9])[0-9]{8}$/}] },
        ]" placeholder="请输入联系手机号码" />
            </a-form-item>
          </div>

          <div class="flexline">
            <!-- 选择器表单 -->
            <a-form-item :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol" label="签证类型">
              <a-select v-decorator="[ 'visaType', { rules: [{ required: true, message: '请选择签证类型!' }] },]" placeholder="请选择签证类型" @change="selectType">
                <a-select-option v-for="d in qzlxdata" :key="d.DICT_VALUE">
                  {{ d.DICT_VALUE_NAME }}
                </a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol" :label="leibie + ':'" v-if="qztype !== ''">
              <a-select v-decorator=" ['stayType',{ rules: [{ required: true, message: '请选择' +leibie+'!' }] },]" :placeholder="'请选择'+leibie" @change="visitiType">
                <a-select-option v-for="d in visitidata" :key="d.DICT_VALUE">
                  {{ d.DICT_VALUE_NAME }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </div>
          <!-- <a-form-item :label-col="selectItemLayout.labelCol" :wrapper-col="selectItemLayout.wrapperCol" label="上传附件">
            <a-upload :file-list="fileList" name="file" action="http://10.10.152.115:82/api/cloud-fastdfs/fastdfs/upload/file/96F307B9D0EDF9F/4AD13C5F04995EA" :headers="headers" @change="uploadHKB">
                <a-button type="primary">
                  <upload-outlined></upload-outlined>
                  上传
                </a-button>
              </a-upload>
          </a-form-item> -->
        </a-form>
        <div class="uploadStyle">
          上传附件：
          <a-upload :file-list="fileList" :before-upload="beforeUpload" :remove="handleRemove">
            <a-button>
              <upload-outlined></upload-outlined>
              选择文件
            </a-button>
          </a-upload>
        </div>
      </div>
    </div>
    <div class="steps-action">
      <a-button type="primary" @click="reserveOrder" :disabled="fileList.length === 0">确定</a-button>
    </div>
  </div>
</template>

<script>

const formItemLayout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 15 },
};

const selectItemLayout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 15 },
};
import { getQZLXList, getTQLBList, uploading, } from "@/api/goaborad";
import { printHtml } from "@/util/exportPdf.js";
import axios from 'axios'
export default {
  name: "hover-box",
  data () {
    return {
      formItemLayout,
      selectItemLayout,
      form: this.$form.createForm(this, { name: 'dynamic_rule' }),
      qzlxdata: [],
      qztype: '',
      visitidata: [],
      leibie: '',
      fileList: [],
      returnFile: [],
      headers: {
        authorization: 'authorization-text',
      },
    };
  },
  created () {
    this.getQZLXList()
  },
  methods: {
    beforeUpload (file) { // 上传附件
      this.fileList = [...this.fileList, file];
      return false;
    },
    handleRemove (file) {
      console.log(file);
      const index = this.fileList.indexOf(file);
      const newFileList = this.fileList.slice();
      newFileList.splice(index, 1);
      this.fileList = newFileList;
    },
    getQZLXList () {  //获取签证类型列表
      getQZLXList().then((res) => {
        this.qzlxdata = res.data
      })
    },
    getTQLBList (value) {  //获取弹琴类别列表
      getTQLBList(value).then((res) => {
        this.visitidata = res.data
      })
    },
    visitiType (value) {  //探亲类别
      console.log('类别', value);
    },
    selectType (value) { //签证类别
      this.qztype = value;
      this.getTQLBList(value)
      if (value == 0) {
        this.leibie = '探亲类别'
      } else if (value == 1) {
        this.leibie = '在留类别'
      } else if (value == 2) {
        this.leibie = '赴日情况'
      }
    },
    print () {
      let dom = document.querySelector("#maindiv").innerHTML;
      printHtml(dom);
    },
    reserveOrder () {  //确定材料预审
      this.form.validateFields((err, values) => {
        if (!err) {
          var returnFile = []
          this.fileList.map((file, index) => {
            let fd = new FormData();
            fd.append('file', file);
            this.downloadFile(fd).then((res) => {
              let data = res.data.data
              returnFile.push({
                id: data.fileId,
                name: data.fileName,
                url: data.filePath,
                type: data.fileType,
                size: data.fileSize,
              })
            }).catch((res) => {
              console.log(res);
            })
          });

          this.$message.success('正在上传附件，请稍后!');
          setTimeout(() => {
            values.residenceBooklet = JSON.stringify(returnFile)
            uploading(values).then((res) => {
              if (res.code == 200) {
                this.$message.success('材料预审上传成功!');
                this.current = 2
              } else {
                this.current = 1
                this.$message.error(res.message);
              }
            })
          }, 3000);
        }
      });

    },
    downloadFile (data) {
      return axios({
        method: "POST",
        url: 'http://61.154.14.62:9976/api/cloud-fastdfs/fastdfs/upload/file/96F307B9D0EDF9F/B619C66BF478A91',
        // headers: {
        //   'Content-type': 'multipart/form-data'
        // },
        data
      })
    }
  }
};
</script>


<style lang="less" scoped>
.content {
  // text-align: center;
  padding-top: 20px;
  font-family: Microsoft YaHei;
  // width: 800px;
}

.steps-content {
  border: 1px dashed #e9e9e9;
  border-radius: 6px;
  background-color: rgb(250, 251, 251);
  // min-height: 330px;
  text-align: center;
  padding: 30px 0;
}

.steps-action {
  margin-top: 24px;
}

.attention-info {
  text-align: left;
  margin: 20px 30px 0 0;
  line-height: 40px;
  text-align: justify;
  text-justify: inter-ideograph;
  font-size: 16px;
}

.flexline {
  display: flex;
}
.flexline .ant-row {
  width: 50%;
}

.uploadStyle {
  text-align: left;
  margin-left: 64px;
  width: 38%;
}
/deep/.ant-form-item-children {
  display: flex;
}

/deep/.ant-form-explain {
  text-align: left;
}

.title {
  font-size: 18px;
  font-weight: 600;
  display: flex;
  justify-content: left;
  color: rgb(198, 200, 199);
}
.tab-box:nth-child(2) {
  margin: 0 20px;
  // border-bottom: 2px solid rgb(203, 180, 134);
}
.tab-box:hover {
  cursor: pointer;
}

.content-box {
  width: 85%;
  text-align: left;
}
.line {
  margin-top: 20px;
  font-size: 17px;
}
.line1 {
  margin-top: 20px;
  font-size: 17px;
  display: flex;
}
.beizhu {
  margin-left: 50px;
  margin-top: -33px;
  line-height: 40px;
}

.ant-btn-primary {
  background-color: #cbb486 !important;
  border-color: #cbb486 !important;
}
.gold-font {
  color: #cbb486;
}
</style>


// WEBPACK FOOTER //
// src/components/home/preliminaryExamination/components/content-01.vue